import * as apiClient from "./axiosApiClient";
import { joinUrlWithRoute } from "../utils/urlUtils";

const API_BASE = apiClient.REACT_APP_BASE_URL;

export function getWebhooks() {
  const url = joinUrlWithRoute(API_BASE, "/");
  return apiClient.get(url);
}

export function createHostedCheckout(request) {
  const url = joinUrlWithRoute(API_BASE, "/billing/checkout/hosted");
  return apiClient.post(url, request);
}

// ASAAS (legado)
export function checkoutSession(request) {
  const url = joinUrlWithRoute(API_BASE, "/billing/checkout-session");
  return apiClient.post(url, request);
}

// ASAAS (legado)
export function loadBillingSummary() {
  const url = joinUrlWithRoute(API_BASE, "/billing/me");
  return apiClient.get(url);
}

export function getBillingInvoices() {
  const url = joinUrlWithRoute(API_BASE, "/billing/invoices");
  return apiClient.get(url);
}

// ASAAS (legado)
export function upgradeCheckoutSession(payload) {
  const url = joinUrlWithRoute(API_BASE, "/billing/upgrade-checkout");
  return apiClient.post(url, payload);
}

export function getBillingPlans() {
  const url = joinUrlWithRoute(API_BASE, "/billing/plans");
  return apiClient.get(url);
}

export function getBillingStatus() {
  const url = joinUrlWithRoute(API_BASE, "/billing/status");
  return apiClient.get(url);
}

export function cancelSubscription() {
  const url = joinUrlWithRoute(API_BASE, "/billing/cancel-subscription");
  return apiClient.post(url);
}

export function resumeSubscription() {
  const url = joinUrlWithRoute(API_BASE, "/billing/resume-subscription");
  return apiClient.post(url);
}

export function cancelScheduledDowngrade() {
  const url = joinUrlWithRoute(API_BASE, "/billing/cancel-scheduled-downgrade");
  return apiClient.post(url);
}

// STRIPE (novo)
export function stripeCheckout(payload) {
  const url = joinUrlWithRoute(API_BASE, "/billing/checkout");
  return apiClient.post(url, payload);
}

// STRIPE (novo)
export function stripeCheckoutStatus(sessionId) {
  const url = joinUrlWithRoute(
    API_BASE,
    `/billing/checkout/status?session_id=${encodeURIComponent(
      sessionId || ""
    )}`
  );
  return apiClient.get(url);
}

// STRIPE (novo)
export function stripePortal(payload) {
  const url = joinUrlWithRoute(API_BASE, "/billing/portal");
  return apiClient.post(url, payload);
}

// Novo /me/billing (caso você queira migrar depois)
export function loadMeBillingV1() {
  const url = joinUrlWithRoute(API_BASE, "/me/billing");
  return apiClient.get(url);
}
